import { lazy, Suspense } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import Circular from 'utils/Loader';
import StartKyc from 'views/pages/authentication/auth-forms-structrue/StartKycPage';
import ReuploadPage from 'PendingRequest/ReuploadPage';
// import ForgetPassword from 'views/pages/AgentSignin_Link/authentication3/ForgetPassword';
// import ForgetPassword from 'views/pages/authentication/authentication3/ForgetPassword';

// C:\Users\sanja\OneDrive\Desktop\agam\GitLab\frontend-agent-onboarding\src\views\pages\authentication\auth-forms-structrue\ForgetPassword.js

// login option 3 routing
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/auth-forms-structrue')));
const AgentSignin = Loadable(lazy(() => import('views/pages/authentication/auth-forms-structrue/AgentSignin')));
const PopularService = Loadable(lazy(() => import('views/utilities/PopularServices')));
const ForgetPassword= Loadable(lazy(() => import('views/pages/authentication/auth-forms-structrue/ForgetPassword')))
const ChangePassword = Loadable(lazy(() => import('views/pages/authentication/auth-forms-structrue/ChangePassword')));
const ForgetPasswordAgentTm = Loadable(lazy(() => import('views/pages/AgentSignin_Link/authentication3/ForgetPassword')));
// const ForgetPassword= Loadable(lazy(() => import('views/pages/authentication/auth-forms-structrue/ForgetPassword')))

const DSProductForm = Loadable(lazy(() => import('views/dashboard/Default/DS Onboarding/ProductForm')));

// const AgentLanding = Loadable(lazy(() => import('views/utilities/Landing/Home/index')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',

      element: (
        <Suspense fallback={<Circular />}>
          <StartKyc />
        </Suspense>
      ),
      breadcrumbs: true
    },
    {
      path: '/Onboarding',
      element: (
        <Suspense fallback={<Circular />}>
          <AuthRegister3 />
        </Suspense>
      )
    },
    {
      path: '/forget-password',
      element: (
        <Suspense fallback={<Circular />}>
          <ForgetPassword />
        </Suspense>
      )
    },
    {
      path: '/Signin',
      element: (
        <Suspense fallback={<Circular />}>
          <AgentSignin />
        </Suspense>
      )
    },
    {
      path: '/recharge',
      element: (
        <Suspense fallback={<Circular />}>
          <PopularService />
        </Suspense>
      ),
      breadcrumbs: true
    },
    {
      path: '/changePassword',
      element: (
        <Suspense fallback={<Circular />}>
          <ChangePassword />
        </Suspense>
      ),
      breadcrumbs: true
    },
    {
      path: '/changePasswordAgentTm',
      element: (
        <Suspense fallback={<Circular />}>
          <ForgetPasswordAgentTm />
        </Suspense>
      ),
      breadcrumbs: true
    },
    {
      path: '/uploadocs',
      element: (
        <Suspense fallback={<Circular />}>
          <ReuploadPage/>
        </Suspense>
      ),
      breadcrumbs: true
    },
    {
      path: 'dsform',
      children: [
        {
          path: 'product/:type',
          element:  (
            <Suspense fallback={<Circular />}>
               {<DSProductForm />}
            </Suspense>
          )
        }
      ]
    }
  ]
};

export default AuthenticationRoutes;
